/**
 * @generated SignedSource<<11096bf01a341dbdd068e6b9d9a535e7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ArchiveMailingListInput = {
  id: string;
};
export type MailingListDetailsViewArchiveMutation$variables = {
  input: ArchiveMailingListInput;
};
export type MailingListDetailsViewArchiveMutation$data = {
  readonly archiveMailingList: {
    readonly archivedAt: any | null | undefined;
    readonly id: string;
  };
};
export type MailingListDetailsViewArchiveMutation = {
  response: MailingListDetailsViewArchiveMutation$data;
  variables: MailingListDetailsViewArchiveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MailingList",
    "kind": "LinkedField",
    "name": "archiveMailingList",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "archivedAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MailingListDetailsViewArchiveMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MailingListDetailsViewArchiveMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "595d8f6b1ea304add4481dda584457a5",
    "id": null,
    "metadata": {},
    "name": "MailingListDetailsViewArchiveMutation",
    "operationKind": "mutation",
    "text": "mutation MailingListDetailsViewArchiveMutation(\n  $input: ArchiveMailingListInput!\n) {\n  archiveMailingList(input: $input) {\n    id\n    archivedAt\n  }\n}\n"
  }
};
})();

(node as any).hash = "2803b46b919845b8a29188cadc310d19";

export default node;
